import API from '@/api/callApi.js';
import endpoints from '@/api/endpoints';

export default {
  namespaced: true,
  state: {
    scenarios: [],
    kpi: null,
    selectedScenario: {},
    ref_segments: [
      {
        code: "MORNING",
        title: "Good Morning",
        color: "#16e0a0"
      },
      {
        code: "LUNCH",
        title: "Pause Dej",
        color: "#fd8f0a"
      },
      {
        code: "AFTERWORK",
        title: "Afterwork",
        color: "#ffc306"
      },
      {
        code: "DINER",
        title: "Diner",
        color: "#94c0ff"
      }, {
        code: "FIDELITY",
        title: "Fidelité",
        color: "#ff6685"
      }, {
        code: "WEEKEND",
        title: "Weekend",
        color: "#34b2a8"
      }, {
        code: "ALL",
        title: "Tout le temps",
        color: "#ff7461"
      }
    ],
    enabling: false,
    disabling: false
  },

  mutations: {
    setScenariosData(state, value) {
      state.scenarios = value;
    },
    setScenariosDataById(state, value) {
      state.selectedScenario = {
        ...value
      }
    },
    setScenarioContentField(state, params) {
      state.selectedScenario[params.field] = params.value;
    },
    setScenarioKPI(state, value) {
      state.kpi = value;
    },
    setEnabling(state, value) {
      state.enabling = value;
    },
    setDisabling(state, value) {
      state.disabling = value;
    }

  },

  actions: {
    scenariosData({
      commit
    }, parameters) {
      API.makeGet(endpoints.baseURL + endpoints.endpoints.allScenarios, null, true)
        .then(response => {
          commit('setScenariosData', response.data.payload)
        }).catch(error => {
          let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
          commit('ui/triggerAlert', {
            type: 'error',
            msg: 'Aucune campagne pour le moment'
          }, { root: true });
        })
    },

    scenarioKPI(
      {
        commit,
        state
      },
      parameters
    ) {

      if (state.kpi !== null) {
        return;
      }

      commit('setScenarioKPI');

      let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.activeScenarios, { establishment_id: parameters.parameters.establishment_id });

      API.makeGet(url, null, true).then(response => {
        commit('setScenarioKPI', response.data.payload);
        parameters.success(response.data.payload);
      }).catch(error => {
        let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
        commit('ui/triggerAlert', {
          type: 'error',
          msg: 'KPI ERROR'
        }, { root: true });
      })
    },

    loadScenarioDataById(
      {
        state,
        commit
      },
      { parameters, callback }
    ) {

      let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.scenarios, { scenario_id: parameters.id });

      commit('ui/setLoadingBarState', true, { root: true });

      API.makeGet(url, null, true).then(response => { // console.log('response scenario by id ====>', response);
        commit('setScenariosDataById', response.data.payload);
        callback();
      }).catch(error => {
        let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
        commit('ui/triggerAlert', {
          type: 'error',
          msg: 'Aucun détail de campagne pour le moment'
        }, { root: true });
      }).finally(() => {
        commit('ui/setLoadingBarState', false, { root: true });
      });
    },

    addScenario({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        API.makePost(endpoints.baseURL + endpoints.endpoints.createScenarios, {
          'scenario': params.scenario,
          'scenarioContent': params.scenarioContent
        }, true).then(response => {
          commit('ui/triggerAlert', {
            type: 'success',
            msg: 'Campagne ajoutée avec succès'
          }, { root: true });
          resolve(response.data.payload)
        }).catch(error => {
          let m = error.response ? error.response.data : (error.request ? error.request.response : error.message);
          commit('ui/triggerAlert', {
            type: 'error',
            msg: 'Votre campagne n\'a pas pu être ajoutée '
          }, { root: true });
          reject()
        })
      })
    },

    upsertScenarioContentById(
      {
        state,
        commit
      },
      parameters
    ) {

      if (state.scenarios.upserting) {
        return;
      }

      let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.updateScenario, { scenario_id: state.selectedScenario.id });

      API.makePost(url, parameters.parameters, true).then(response => {
        commit('ui/triggerAlert', {
          type: 'success',
          msg: "Votre campagne personnelle a bien été mise à jour."
        }, { root: true });
        parameters.success(response);
      }).catch(response => {
        commit('ui/triggerAlert', {
          type: 'error',
          msg: "Une erreur est survenue lors de la mise à jour de la campagne."
        }, { root: true });
      })

    },

    deleteScenarioContentById(
      { state, commit }
    ) {

      if (state.scenarios.upserting) {
        return;
      }
      let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.deleteScenario, { scenario_id: state.selectedScenario.id });

      API.makePost(url, state.selectedScenario, true).then(response => {
        commit('ui/triggerAlert', {
          type: 'success',
          msg: "Votre campagne personnelle a bien été supprimé."
        }, { root: true });
      }).catch(response => {
        commit('ui/triggerAlert', {
          type: 'error',
          msg: "Une erreur est survenue lors de la suppression de la campagne."
        }, { root: true });
      })
    },

    enableScenario(
      {
        state,
        commit
      },
      parameters
    ) {
      if (state.enabling) {
        return;
      }

      commit('setEnabling', true);

      let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.enableScenario, { scenario_id: parameters.scenario_id });

      API.makePost(url, {}, true).then(response => {
        commit('ui/triggerAlert', {
          type: 'success',
          msg: 'Scenario activé'
        }, { root: true });

        const scenariosList = []
        for (let scenario of state.scenarios) {
          if (scenario.id === parameters.scenario_id) {
            scenario.is_active = true;
          }
          scenariosList.push(scenario)
        }
        commit('scenarios/setScenariosData', scenariosList, { root: true })
      }).catch(response => {
        commit('ui/triggerAlert', {
          type: 'error',
          msg: 'Une erreur est survenue'
        }, { root: true });
      }).finally(response => {
        commit('setEnabling', false);
      });

    },

    disableScenario(
      {
        state,
        commit
      },
      parameters
    ) {

      if (state.disabling) {
        return;
      }

      commit('setDisabling', true);

      let url = endpoints.baseURL + API.processUrl(endpoints.endpoints.disableScenario, { scenario_id: parameters.scenario_id });

      API.makePost(url, {}, true).then(response => {
        commit('ui/triggerAlert', {
          type: 'success',
          msg: 'Scenario désactivé'
        }, { root: true });

        const scenariosList = []
        for (let scenario of state.scenarios) {
          if (scenario.id === parameters.scenario_id) {
            scenario.is_active = false;
          }
          scenariosList.push(scenario)
        }
        commit('scenarios/setScenariosData', scenariosList, { root: true })
      }).catch(response => {
        commit('ui/triggerAlert', {
          type: 'error',
          msg: 'Une erreur est survenue'
        }, { root: true });
      }).finally(response => {
        commit('setDisabling', false);
      });
    }

  }
};
